import React, { PureComponent } from 'react';
import { connect } from "react-redux";
import { Platform, Dimensions, View, Image, Text, StyleSheet, StatusBar, ScrollView,
         TouchableHighlight, TouchableOpacity, PermissionsAndroid } from 'react-native';
import { Left, Body, Right, Item, Button as NButton, CheckBox } from "native-base";
import { Card, CardHeader, CardBody, Container, Row, Col, Button, Input, Media, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import * as Helper from "../../utils/Helper";
//import FastImage from 'react-native-fast-image';
import BaseScreen from "../../components/base/BaseScreen";
import { NavigationService, NavigateActionTypes } from "../../navigation";
import MessageBox from "../../components/ui/MessageBox";
import LoadingIndicator from "../../../components/ui/LoadingIndicator";
import Icon from "react-native-vector-icons/Ionicons";
import CustomAnimations from '../../utils/CustomAnimations';
import UIDs from "../../UIDs";
import "antd/dist/antd.css";
import { withTranslation } from "react-i18next";
import { blendColor } from '../../utils/BlendColor';
import IsMobile from '../../utils/IsMobile';
import { Actions, ActionTypes, reducer, INITIAL_STATE } from "../../redux/components/chinesepark/SpokenBooksRedux.js";
import EllipsisText from "../../../components/ui/EllipsisText";
import Word from "../../../components/ui/Word";
import { GetCountOfMarkTypeFromSentence } from "../../../utils/MarkTextHelper";
import Constants from "../../../config/Constants";
import CollapseImg from "../../../components/ui/CollapseImg";
import CollapseUnitView from "../../../components/ui/CollapseUnitView";
import RoomClient from "../../utils/chinesepark/RoomClient";
import _ from 'lodash';

const uid = UIDs.components.chinesepark.spokenBooksModal;

const SpokenUnitTypes = ["POKA1", "PSKA1"];
const ReadingUnitTypes = ["POKA2"]

const MaxShowWords = 50;

class InputUnitView extends React.Component  {
    constructor(props) {
        super(props);
        this.state = {
            showAll: false,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.showAll !== nextState.showAll) {
            return true;
        }
        if (this.props.unit.id !== nextProps.unit.id) {
            return true;
        }
        if (this.props.index !== nextProps.index) {
            return true;
        }
        if (this.props.selectedCourseType !== nextProps.selectedCourseType) {
            return true;
        }
        if (this.props.selectedUnits !== nextProps.selectedUnits) {
            return true;
        }
        if (this.props.selectedLastUnits !== nextProps.selectedLastUnits) {
            const unit = this.props.unit;
            if (SpokenUnitTypes.includes(unit.unitType)) {
                if (!_.isEqual(this.props.selectedLastUnits, nextProps.selectedLastUnits)) {
                    return true;
                }
            }
        }
        return false;
    }

    onCollapse = () => {
        this.setState({showAll: !this.state.showAll});
    };

    getHasKeyWordsArray = (dialogs, dialogPersons) => {
        let arr = new Array(dialogPersons);
        if (dialogs) {
            _.each(dialogs, ({ role, sentences }, i) => {
                if (sentences) {
                    _.each(sentences, (sentence, j) => {
                        if (!arr[role]) {
                            arr[role] = GetCountOfMarkTypeFromSentence(sentence.chars.join(""), Constants.TEXT_MARK_TYPE.KEYWORD) > 0;
                        }
                    });
                }
            });
        }

        return arr;
    }

    render() {
        const { unit, index, selectedCourseType, selectedUnits, selectedLastUnits } = this.props;

        const data = JSON.parse(unit.data).singleUnits[0];
        const { dialogs, dialogPersons } = data;
        let hasKeyWords = this.getHasKeyWordsArray(dialogs, dialogPersons);
        let showWordCount = 0;
        const content = (
            <div>
                {dialogs &&
                 dialogs.map(({ role, sentences }, i) => {
                     if ((!this.state.showAll) && (showWordCount > MaxShowWords)) {
                         return null;
                     }
                     return (
                         <div key={i} style={{ display: "flex", alignItems: "center", flexWrap: "wrap", fontSize: 18 }}>
                             <span style={{ lineHeight: "36px", margin: "4px 4px 0 0" }}>{getRoleName(role)}:</span>
                             {sentences &&
                              sentences.map((sentence, j) => {
                                  if ((!this.state.showAll) && (showWordCount > MaxShowWords)) {
                                      return null;
                                  }

                                  let words = sentence.words;
                                  return (
                                      words.map((word, k) => {
                                          showWordCount += 1;
                                          if ((!this.state.showAll) && (showWordCount > MaxShowWords)) {
                                              return null;
                                          }
                                          return <Word key={k}
                                                       pinyinVisible={false}
                                                       data={word}
                                                 />
                                      })
                                  )
                              })}
                         </div>
                     );
                 })
                }
            </div>
        );

        if (selectedCourseType === 0) {
            return (
                <div key={`unit-${unit.id}`} style={{ padding: "10px 0" }} >
                    <div style={{ lineHeight: "46px" }} >
                        {SpokenUnitTypes.includes(unit.unitType) ?
                         (<Row style={{ lineHeight: "46px" }}>
                              <Col>
                                  <label style={{ verticalAlign: "middle", margin: 0, cursor: "pointer" }} >{this.props.t("practiceIndex", { index: index + 1 })}</label>
                              </Col>
                              <Col xs="4" className="text-right">
                              </Col>
                          </Row>) :
                         (<>
                              <Input addon type="checkbox" style={{ verticalAlign: "middle", margin: "2px 10px 0 0", cursor: "pointer" }} checked={selectedUnits.has(`${unit.id}-100-0`)} onChange={()=>this.props.selectUnit(`${unit.id}-100-0`)} />
                              <label style={{ verticalAlign: "middle", margin: 0, cursor: "pointer" }} htmlFor={`checkbox-${unit.id}`}>{this.props.t("practiceIndex", { index: index + 1 })}</label>
                          </>)}
                    </div>
                    <div style={{ border: "1px solid #eee", borderRadius: 10, marginTop: 5 }}>
                        <div style={{ backgroundColor: "#FF7200", borderTopLeftRadius: 10, borderBottomRightRadius: 10, paddingHorizontal: 15, paddingVertical: 15, fontSize: 10, position: "absolute" }}>
                            <span style={{ color: "#fff", marginLeft: 10, marginRight: 10 }}>{this.props.t("badge" + dialogPersons)}</span>
                        </div>
                        <div style={{ display: "none" }}>
                            {content}
                        </div>
                        <EllipsisText content={content} badge={true} onClickContent={()=>this.props.selectUnit(`${unit.id}-100-0`)}
                                      onCollapse={this.onCollapse} showAll={this.state.showAll}/>
                    </div>
                </div>
            )
        }

        return (
            <div key={`unit-${unit.id}`} style={{ padding: "10px 0" }} >
                <Row style={{ lineHeight: "46px" }}>
                    <Col>
                        <label style={{ verticalAlign: "middle", margin: 0, cursor: "pointer" }} >{this.props.t("practiceIndex", { index: index + 1 })}</label>
                    </Col>
                    <Col xs="4" className="text-right">
                    <Button color="primary" size="sm" disabled={selectedUnits.has(unit.id)} onClick={() => { this.props.selectUnit(unit.id); }}>
                    <i className="fa fa-plus mr-2" aria-hidden="true"></i>
                    {this.props.t("select")}
                    </Button>
                    </Col>
                </Row>
                <div style={{ border: "1px solid #eee", borderRadius: 10, marginTop: 5, backgroundColor: '#fff' }}>
                    <div style={{ backgroundColor: "#FF7200", borderTopLeftRadius: 10, borderBottomRightRadius: 10, paddingHorizontal: 15, paddingVertical: 15, fontSize: 10, position: "absolute" }}>
                        <span style={{ color: "#fff", marginLeft: 10, marginRight: 10 }}>{this.props.t("badge" + dialogPersons)}</span>
                    </div>
                    <div style={{ display: "none" }}>
                        {content}
                    </div>
                    <EllipsisText content={content} badge={true}
                                  onCollapse={this.onCollapse} showAll={this.state.showAll}/>
                </div>
            </div>
        );
    }
}

class SelectedUnitView extends React.Component  {
    constructor(props) {
        super(props);
        this.state = {
            showAll: false,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.showAll !== nextState.showAll) {
            return true;
        }

        if (this.props.reviseUnits.get(this.props.id) !==
            nextProps.reviseUnits.get(nextProps.id))
        {
            return true;
        }
        return (this.props.id !== nextProps.id) || (this.props.index !== nextProps.index);
    }

    onCollapse = () => {
        this.setState({showAll: !this.state.showAll});
    };

    render() {
        const { id, index, unit, reviseUnits } = this.props;
        const [unitId, practiceRole, practiceType] = id.split('-');

        let unitView = null;

        const data = JSON.parse(unit.data).singleUnits[0];
        const { dialogs, dialogPersons } = data;
        let showWordCount = 0;
        const content = (
            <div>
                {dialogs &&
                 dialogs.map(({ role, sentences }, i) => {
                     if ((!this.state.showAll) && (showWordCount > MaxShowWords)) {
                         return null;
                     }
                     return (
                         <div key={i} style={{ display: "flex", alignItems: "center", flexWrap: "wrap", fontSize: 18 }}>
                             <span style={{ lineHeight: "36px", margin: "4px 4px 0 0" }}>{getRoleName(role)}:</span>
                             {sentences &&
                              sentences.map((sentence, j) => {
                                  if ((!this.state.showAll) && (showWordCount > MaxShowWords)) {
                                      return null;
                                  }
                                  let words = sentence.words;
                                  return (
                                      words.map((word, k) => {
                                          showWordCount += 1;
                                          if ((!this.state.showAll) && (showWordCount > MaxShowWords)) {
                                              return null;
                                          }
                                          return <Word key={k}
                                                       pinyinVisible={false}
                                                       data={word}
                                                 />
                                      })
                                  )
                              })}
                         </div>
                     );
                 })
                }
            </div>
        );
        unitView = (
            <div style={{ border: "1px solid #eee", borderRadius: 10, marginTop: 5, backgroundColor: '#fff' }}>
                <div style={{ backgroundColor: "#FF7200", borderTopLeftRadius: 10, borderBottomRightRadius: 10, paddingHorizontal: 15, paddingVertical: 15, fontSize: 10, position: "absolute" }}>
                    <span style={{ color: "#fff", marginLeft: 10, marginRight: 10 }}>{this.props.t("badge" + dialogPersons)}</span>
                </div>
                <div style={{ display: "none" }}>
                    {content}
                </div>
                <EllipsisText content={content} badge={true}
                              onCollapse={this.onCollapse} showAll={this.state.showAll}/>
            </div>
        );

        let canRevise = unit.isSubjective;
        if ((!canRevise) && (unit.unitType === 'POKA1')) {
            canRevise = (practiceType !== '0');
        }
        return (
            <div key={`unit-${id}`} style={{ padding: "10px 0" }} >
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    {this.props.t('selected')}
                </div>
                <div style={{ position: "relative" }}>
                    <i className="fa fa-minus-circle" aria-hidden="true"
                        style={{ position: "absolute", top: -8, right: 0, color: "red", fontSize: 24 }}
                        onClick={() => this.props.selectUnit(id)}
                    ></i>
                    {unitView}
                </div>
            </div>
        );
    }
}

class SpokenBooksModal extends BaseScreen {
    localVars = {
        navParams: {}
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);

        this.state = {
            pkstate: RoomClient.pkstate,
        };
        this.onPKState = this.onPKState.bind(this);
    }

    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: this._handleLoadScreenViewAsyncDone, error: this._handleAsyncActionError },
        };
    }

    componentDidMount() {
        super.componentDidMount();

        RoomClient.events.addListener("onPKState", this.onPKState);

        // call load screen view to update analytics
        let { searchVO } = this.props.localState;
        searchVO = { ...searchVO, partnerId: (this.props.partner ? this.props.partner.id : null) };
        const { units, selectedUnits, reviseUnits } = this.localVars.navParams;
        this.props.loadScreenViewAsync(searchVO, units, selectedUnits, reviseUnits);
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        RoomClient.events.removeListener("onPKState", this.onPKState);
    }

    _handleLoadScreenViewAsyncDone = () => {
        this._hanldeSelectCourse(this.props.courseId);
    }

    _handleAsyncActionError = (action) => {
        MessageBox.danger({
            text: action.error.message,
            position: "center",
            duration: 5000
        });
    };

    onPKState(state) {
        this.setState({pkstate: state});
    }

    renderBody() {
        const { courseTypes, courses, sections, units, selectedCourseType, selectedSectionType, selectedCourse, selectedSection, selectedUnits, selectedLastUnits } = this.props.localState;
        let isDisabled = this.isActionExecuting(ActionTypes.LOAD_SECTIONS_ASYNC) || this.isActionExecuting(ActionTypes.LOAD_UNITS_ASYNC) || this.isActionExecuting(ActionTypes.SAVE_HOMEWORK_UNITS_ASYNC);

        return (<CardBody>
                    <Row>
                        <Col>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                             {/*<Input type="select" disabled={true} value={selectedCourseType === null ? "" : selectedCourseType}
                                       onChange={e => this.props.selectCourseType(parseInt(e.target.value))}>
                                    <option value="" disabled style={{ display: "none" }}>{this.props.t("selectCourseType")}</option>
                                    {Object.entries(courseTypes).map(([key, value], i) => {
                                        return <option key={i} value={key}>{this.props.t(value)}</option>
                                    })}
                                </Input>*/}
                                <Input type="select" style={{ marginRight: "20px" }} disabled={true || selectedCourseType === null} value={selectedCourse || ""}
                                       onChange={e => this._hanldeSelectCourse(e.target.value)}>
                                    <option value="" disabled style={{ display: "none" }}>{this.props.t("selectCourse")}</option>
                                    {courses && courses.map((item, i) => {
                                        return <option key={i} value={item.id}>{Helper.subString(item.title, 0, 30, true)}</option>
                                    })}
                                </Input>
                                <Input type="select" disabled={selectedCourse === null} value={selectedSection || ""}
                                       onChange={e => this._hanldeSelectSection(e.target.value)}>
                                    <option value="" disabled style={{ display: "none" }}>{this.props.t("selectSection")}</option>
                                    {sections && sections.filter(s => s.courseId === selectedCourse).map((item, i) => {
                                        return <option key={i} value={item.id}>{this.props.t("sectionIndex" + selectedSectionType, { index: 1 + i }) + Helper.subString(item.title, 0, 30, true)}</option>
                                    })}
                                </Input>
                            </div>
                            {units &&
                             <div>
                                 {selectedCourseType === 0 && selectedSection &&
                                  <div style={{ lineHeight: "46px", marginBottom: -10 }}>
                                      <Input addon type="checkbox" id={`checkbox-all`} style={{ verticalAlign: "middle", margin: "2px 10px 0 0", cursor: "pointer" }}
                                             checked={selectedUnits.size > 0 && units.filter(u => u.sectionId === selectedSection).every(u => selectedUnits.has(u.id) || selectedUnits.has(`${u.id}-100-0`))} onChange={e => { this.props.selectUnit(null, e.target.checked); }} />
                                      <label style={{ verticalAlign: "middle", margin: 0, cursor: "pointer" }} htmlFor={`checkbox-all`}>{this.props.t("selectAll")}</label>
                                  </div>
                                 }
                                 {units.filter(u => u.sectionId === selectedSection).map((unit, index) => {
                                     return (<InputUnitView key={`unit-${unit.id}`}
                                                            t={this.props.t} unit={unit} index={index}
                                                            selectUnit={this.props.selectUnit}
                                                            selectedCourseType={selectedCourseType}
                                                            selectedUnits={selectedUnits}
                                                            selectedLastUnits={selectedLastUnits}/>);
                                 })}
                             </div>
                            }
                        </Col>
                        <Col style={{ marginLeft: 30 }}>
                            <SortableList
                                items={[...selectedUnits]}
                                onSortEnd={this._hanldeReorderUnits}
                                renderItemView={this._renderUnit}
                                axis="y"
                                pressDelay={200} />
                        </Col>
                    </Row>
                </CardBody>);
    }

    render() {
        const screenWidth = Dimensions.get("window").width;
        const modalWidth = IsMobile() ? screenWidth * 0.9 : 400;
        const buttonWidth = modalWidth / 2 - 30;
        const maxTitleWidth = modalWidth - 90;
        const { selectedUnits } = this.props.localState;
        return (<View style={{zIndex: 100, position: 'absolute', left: 0, top: 0, right: 0, bottom: 0,
                              flexDirection: 'column', backgroundColor: '#f4f6f9'}}>
                    <View style={{flexDirection: 'row', height: 60, backgroundColor: '#fff',
                                  alignItems: 'center', justifyContent: 'center'}}>
                        <View style={{flexDirection: 'column', alignItems: 'center'}}>
                            <Text style={{fontSize: 18}}>{this.props.t("selectPKBook")}</Text>
                            <Text style={{marginTop: 4, fontSize: 12}}>
                                <Text style={{color: '#fa353a'}}>
                                    {this.state.pkstate.selectBookTime}s
                                </Text>
                                {this.props.t("chooseDialogCountDown")}
                            </Text>
                        </View>
                        <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center',
                                      position: 'absolute', top: 7, right: 50}}>
                            <NButton transparent onPress={() => {
                                         const units = Array.from(selectedUnits);
                                         if (units.length === 0) {
                                             MessageBox.show({
                                                 text: this.props.t('pleaseSelectBook'),
                                                 position: "center",
                                                 duration: 5000
                                             });
                                             return;
                                         }

                                         const [unitId, practiceRole, practiceType] = units[0].split('-');
                                         const unit = this.props.localState.units.find(u => u.id === unitId);
                                         const unitData = JSON.parse(unit.data);
                                         if (unitData.singleUnits[0].dialogPersons < 2 ||
                                             unitData.singleUnits[0].dialogPersons > 6)
                                         {
                                             MessageBox.show({
                                                 text: this.props.t('invalidDialogPersons'),
                                                 position: "center",
                                                 duration: 5000
                                             });
                                             return;
                                         }

                                         this.props.onOK(units[0]);
                                    }}>
                                <View style={{height: 30, backgroundColor: '#27cded',
                                              paddingLeft: 12, paddingRight: 12,
                                              borderRadius: 6, alignItems: 'center', justifyContent: 'center'}}>
                                    <Text style={{color: '#fff'}}>{this.props.t('ok')}</Text>
                                </View>
                            </NButton>
                            <View style={{flex: 1}}/>
                            <NButton transparent onPress={() => {
                                        this.props.onCancel();
                                    }}>
                                <View style={{height: 30, backgroundColor: '#192c4d',
                                              marginLeft: 16, paddingLeft: 12, paddingRight: 12,
                                              borderRadius: 6, alignItems: 'center', justifyContent: 'center'}}>
                                    <Text style={{color: '#fff'}}>{this.props.t('back')}</Text>
                                </View>
                            </NButton>
                        </View>
                    </View>
                    {this.isActionDone(ActionTypes.LOAD_SCREEN_VIEW_ASYNC) ?
                     this.renderBody() : (<LoadingIndicator />)}
                </View>);
    }

    _renderUnit = (id, index) => {
        const [unitId, practiceRole, practiceType] = id.split('-');
        const unit = this.props.localState.units.find(u => u.id === unitId);
        return (<SelectedUnitView key={`unit-${id}`} t={this.props.t} id={id}
                                  unit={unit} index={index}
                                  selectUnit={this.props.selectUnit}
                                  reviseUnit={this.props.reviseUnit}
                                  reviseUnits={this.props.localState.reviseUnits}/>);
    }

    _hanldeSelectCourse = courseId => {
        this.props.selectCourse(courseId);
        const { sections } = this.props.localState;
        if (!(sections && sections.some(s => s.courseId === courseId))) {
            this.props.loadSectionsAsync(this.props.partner ? this.props.partner.id : null, courseId);
        }
    }

    _hanldeSelectSection = sectionId => {
        this.props.selectSection(sectionId);
        const { units } = this.props.localState;
        if (!(units && units.some(s => s.sectionId === sectionId))) {
            this.props.loadUnitsAsync(this.props.partner ? this.props.partner.id : null, sectionId);
        }
    }
};

const SortableList = SortableContainer(({ items, renderItemView }) => {
    return (
        <div>
            {items.map((item, index) => {
                return (
                    <SortableItem
                        key={`item-${item}`}
                        item={item}
                        index={index}
                        itemIndex={index}
                        renderItemView={renderItemView}
                    />
                )
            })}
        </div>
    );
})

const SortableItem = SortableElement(({ item, itemIndex, renderItemView }) => (
    <div>
        {renderItemView(item, itemIndex)}
    </div>
))

const getRoleName = (role) => String.fromCharCode(role + 65);

const getTypeName = (type) => {
    switch (type) {
        case 0: return "text";
        case 1: return "keywords";
        case 2: return "noTips";
        default: return "";
    }
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
        user: state.session.user,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: (vo, units, selectedUnits, reviseUnits) => dispatch(Actions.loadScreenViewAsync(vo, units, selectedUnits, reviseUnits)),
        loadSectionsAsync: (partnerId, courseId) => dispatch(Actions.loadSectionsAsync(partnerId, courseId)),
        loadUnitsAsync: (partnerId, sectionId) => dispatch(Actions.loadUnitsAsync(partnerId, sectionId)),
        selectCourseType: id => dispatch(Actions.selectCourseType(id)),
        selectCourse: id => dispatch(Actions.selectCourse(id)),
        selectSection: id => dispatch(Actions.selectSection(id)),
        selectUnit: (id, checked) => dispatch(Actions.selectUnit(id, checked)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation(uid, { withRef: true })(SpokenBooksModal));
